import api from "../../../../../features/auth/axiosConfig";

export const getEmployees = async () => {
  const res = await api.get(`/pos/v2/get_user`);
  return res.data.result;
};

export const getDeletedEmployees = async () => {
  const res = await api.get(`/pos/v2/add_employee/DeletedUsers`);
  return res.data.result;
};

export const addEmployee = async (data: any) => {
  return api.post(`/pos/v2/add_employee`, data);
};

export const deleteEmployee = async (id: string | number) => {
  return api.delete(`/pos/v2/add_employee/${id}`);
};

export const updateEmployee = async (id: string | number, data: any) => {
  return api.patch(`/pos/v2/add_employee/${id}`, data);
};
